import { observer } from "mobx-react-lite";

import { Stack } from "@bps/fluent-ui";
import { DataFetcher } from "@ui-components/data-fetcher/DataFetcher.tsx";

import { ClinicalReminderPreferenceForm } from "./ClinicalReminderPreferenceForm.tsx";

const ClinicalRemindersPage: React.FC = observer(() => {
  return (
    <DataFetcher
      fetch={({ clinical }) =>
        Promise.all([
          clinical.getClinicalActivitiesPreferenceByTenant(),
          clinical.loadActivityDescriptions()
        ])
      }
    >
      {() => (
        <Stack tokens={{ childrenGap: 16 }}>
          <ClinicalReminderPreferenceForm />
        </Stack>
      )}
    </DataFetcher>
  );
});

// eslint-disable-next-line import/no-default-export
export default ClinicalRemindersPage;
